import { render } from "./ExtensionPanel.vue?vue&type=template&id=4d16db40&ts=true"
import script from "./ExtensionPanel.vue?vue&type=script&lang=ts"
export * from "./ExtensionPanel.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\www\\.dev\\.vue\\n3t.bitbucket.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__